import { cssVarFromCssVarFunc } from './css-variable-from-css-variable-function';
import { cssVarFuncFallback } from './css-variable-function-fallback';
import { isCssVar } from './is-css-variable';
import { isCssVarFunc } from './is-css-variable-function';
import { isHexColor } from './is-hex-color';
import { valueFromCssVar } from './value-from-css-variable';
/**
 * Convert HEX color to RGBA counterpart, with optional alpha setting
 *
 * @param hexColor HEX color code, starts with hash followed by either 3 or 6 digits
 * @param alpha Adjusted opacity of the color, 0 means fully transparent and 1 fully opaque
 * @returns RGBA color code
 */
export function hexToRgba(hexColor, alpha) {
    var _a;
    if (alpha === void 0) { alpha = 1; }
    var color = hexColor;
    // If a CSS Variable or CSS variable function is provided, obtain the resolved or fallback value of it
    if (isCssVarFunc(color)) {
        var cssVar = cssVarFromCssVarFunc(color);
        color = (_a = valueFromCssVar(cssVar)) !== null && _a !== void 0 ? _a : cssVarFuncFallback(color);
    }
    else if (isCssVar(color)) {
        color = valueFromCssVar(color);
    }
    if (color == null || !isHexColor(color)) {
        throw new Error("Couldn't parse the color string. Please provide the color as a string in HEX notation.");
    }
    if (alpha < 0 || alpha > 1) {
        throw new Error('Invalid alpha value. Please provide a value in range between 0 and 1.');
    }
    var colorCode = color.slice(1); // remove hash
    var group = colorCode.length / 3;
    return "rgba(".concat([0, 1, 2]
        .map(function (index) {
        return colorCode.slice(index * group, (index + 1) * group);
    })
        .map(function (value) {
        return parseInt((value + value).slice(-2), 16).toString();
    })
        .concat(alpha.toString())
        .join(', '), ")");
}
